<template>
  <div class="">
    <home-header></home-header>
    <div class="wrapper pt-3 pb-3">
      <div class="row">
        <div class="col">
          <div class="card mobile-hidden mb-3">
            <div id="tree-chart" style="height:420px;padding:10px;"></div>
          </div>

          <div class="bg-white p-3">
            <div class="pb-1" style="float:right">
              <el-button size="small" type="danger" @click="btn_export_data">导出数据
              </el-button>
            </div>
            <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
                           :page-size="this.page.size" :total="this.page.total" :current-page="this.page.index+1">
            </el-pagination>
            <div class="card-block search_list">
              <div v-if="listLoading" class="item">
                <div class="h-420">
                  <div class="loading_position">
                    <i class="el-icon-loading" style="font-size: 25px;margin-left: 10px;margin-bottom: 10px;"></i>
                    <span class="d-block">加载中...</span>
                  </div>
                </div>
              </div>
              <div v-else-if="dataList.length == 0">
                <div class="h-435">
                  <div class="loading_position">
                    <span class="d-block">无数据，请选择其他节点</span>
                  </div>
                </div>
              </div>
              <div v-else>
                <ent-list :dataList="dataList"></ent-list>
                <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
                               :page-size="this.page.size" :total="this.page.total" :current-page="this.page.index+1">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
        <export-data :dlg_export_model="dlg_export_model" :form="form"
                     @exportClose="dlg_export_model=false"></export-data>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/rest";
import util from "../../api/util";
import EntList from "../../components/EntList";
import chartData from "../../api/chartData";
import ExportData from "../../components/ExportData.vue";
import HomeHeader from "../../components/HomeHeader.vue";

export default {
  components: {HomeHeader, ExportData, EntList},
  data() {
    return {
      dataType: "chain",
      menuTitle: "产业链",
      depList: [],
      provs: util.setting.getProvs_slim(),
      prov_sime: true,
      pickerOptions: util.setting.getPickerDateOpt(),
      menuLoading: false,
      buttons: ['注册资金', '地区', '成立时间', '规模', '企业类型', '在营年龄'],
      checkedCities: '注册资金',
      page: {
        total: 0,
        index: 0,
        size: 20,
      },
      panel_page: {
        total: 0,
        index: 0,
        size: 20,
      },
      form: {
        order: "rating",
        entLive: true,
        entDie: false,
        entSep: false,
        chain: '',
        chain_item: '',
        chain_label: '',
        query_field: "company_name",
        aboard: false,
        isBiggest: false,
        isUpper: false,
        idx: "ent",
      },
      dlg_export_model: false,
      folderList: [],
      treeProps: {
        label: 'name',
        value: 'id',
        isLeaf: 'leaf'
      },
      casProps: {
        lazy: true,
        label: 'name',
        value: 'id',
        isLeaf: 'leaf',
        lazyLoad(node, resolve) {
          let api_url = "/dep/list"
          let para = {
            index: 0,
            size: 100,
            parentId: node.data.id,
          }
          api.remote.doPost(para, api_url).then((res) => {
            var data = res.content
            resolve(data);
          })
        },
      },
      dlg_detail: false,
      dlg_show_chart: false,
      sltItem: {},
      ent_item: {},
      dataList: [],
      indusList: util.setting.getIndustry(),
      listLoading: false,
      dlg_loading: false,
      collapse: api.storage.get('isCollapse'),
      total_patent: 0,
      total_copyr: 0,
      total_copyw: 0,
      chain_id: 0,
      chain_name: ''
    }
  },
  methods: {
    get_chain_item() {
      let api_url = '/menu/getModel'
      api.remote.doPost(this.chain_id, api_url).then((res) => {
        this.form.chain = res.code
        this.form.chain_item = res
        this.search_action();
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    get_chain_item_by_name() {
      let api_url = '/menu/getModelByName'
      let para = {
        code: this.chain_id,
        label: this.form.chain_label
      }
      api.remote.doPost(para, api_url).then((res) => {
        console.log(res)
        this.form.chain = res.code
        this.form.chain_item = res
        this.search_action();
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },

    btn_export_data() {
      if (api.storage.get('user') == null) {
        this.dlg_login_model = true;
      } else {
        this.form.total = this.page.total
        this.form.totalAmount = this.page.total / 100
        this.dlg_export_model = true;
      }
    },
    search_action() {
      this.dataList = []
      let para = {
        ...this.form,
        ...this.page
      }

      let api_url = '/slice/entQuery'
      api.remote.doPost(para, api_url).then((res) => {
        this.dataList = res.content;
        this.page.total = res.totalElements
        this.listLoading = false;
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    btn_goback() {
      window.location.href = '/#/chain'
    },
    handleTreeClick() {
      let api_url = '/menu/getModelByName'
      let para = {
        code: this.chain_id,
        label: this.form.chain_label
      }
      api.remote.doPost(para, api_url).then((res) => {
        this.form.chain_item = res.content[0]
        this.form.chain = this.form.chain_item.code
        this.search_action()
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    test_tree_chart() {
      // tree_chart
      this.listLoading = true;
      echarts.init(document.getElementById('tree-chart')).dispose();
      var treeChart = echarts.init(document.getElementById('tree-chart'));
      let api_url = '/menu/getTree'
      api.remote.doPost(this.chain_id, api_url).then((res) => {
        console.log(res)
        var treeData = res
        treeData.children.forEach(function (datum, index) {
          index % 2 === 0 && (datum.collapsed = true);
        });
        var treeOption = chartData.chartSetting.getTreeOption()
        treeOption.series[0].data = [treeData]
        treeChart.on('click', (params) => {
          this.form.chain_label = params.name
          this.handleTreeClick()
        });
        treeChart.setOption(treeOption);
        this.get_chain_item()
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    btn_run_query() {
      this.search_action()
    },
    btn_cancel() {
      this.form = {
        adProv: [],
        date_range: [],
        query: "",
        chain: "",
        date_field: "reg_date",
        entLive: true,
        entDie: false,
        entSep: false,
        order: "rating",
        tags: [],
        query_field: "company_name"
      }
    },
    handleNodeClick() {

    },
    depar_click(node) {
      this.form.chain = node.data.value
      this.search_action()
    },
    panel_pagechange(val) {
      this.panel_page.index = val - 1;
      this.getMenuList()
    },

    handleCurrentChange(val) {
      this.page.index = val - 1;
      this.search_action();
    },
  },
  mounted() {
    const script = document.createElement('script');
    if (this.$route.query.id != null) {
      this.chain_id = this.$route.query.id
    }
    script.type = 'text/javascript';
    script.src = `/static/js/echarts.min.js`; // 请替换YOUR_KEY_HERE为你的API密钥
    script.onload = () => {
      // this.initMap();
      this.test_tree_chart();
    };
    document.body.appendChild(script);
  }
}
</script>



// WEBPACK FOOTER //
// ChainDetail.vue?4fceebd5